import type AhaEditor from '../AhaEditor';
import { useSlate } from 'slate-react';
import EditorState, { Namespace, AhaEditorKey } from '../util/EditorState';

// Get the current AhaEditor instance.
const useAhaEditor = (): AhaEditor => {
  const editor = useSlate();
  return EditorState.get(editor, Namespace.AhaEditor, AhaEditorKey.Instance);
};

export default useAhaEditor;
